<template>
  <div class="history">
    <div class="row">
      <div class="col-4 col-md-4 col-lg-3">
        <div id="sidebar-wrapper">
          <Sidebar :routes="routes" />
        </div>
      </div>
      <div class="col-8 col-md-8 col-lg-9">
        <AppointmentHistory />
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from "@/views/Layouts/Sidebar";
import AppointmentHistory from "@/components/Appointments/History.vue";

export default {
  name: "history",
  components: {
    AppointmentHistory,
    Sidebar
  },
  data() {
    return {
      routes: [
        {
          link: "/upcoming",
          title: "Upcoming Appointments"
        },
        {
          link: "/appointment-requests",
          title: "Appointment Requests"
        },
        {
          link: "/history",
          title: "History"
        }
      ]
    };
  }
};
</script>
